import angular from 'angular';

import ColorPaletteModule from './color-palette';
import IconPaletteModule from './icon-palette';

export default angular
    .module('application.component.modals.component.category-edit-modal.component', [
        ColorPaletteModule.name,
        IconPaletteModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-edit-modal/component/index.js